import { gql } from 'react-apollo';
import { full } from '../../../../../graphql/fragments/church';

export const getCurrentUserChurch = gql`
  query getCurrentUserChurch {
    current_user {
      id
      church {
        ...allChurchFields
      }
    }
  }
  
  ${full}
`;

export const getChurch = gql`
  query getChurch($id: Int!) {
    church: church_by_id(id: $id) {
      ...allChurchFields
    }
  }

  ${full}
`;



// WEBPACK FOOTER //
// ./src/components/pages/churchProfile/overview/queries/church.js